import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthProvider';
import { Menu, X, ChevronDown } from 'lucide-react';
import logo from '../assets/logo.jpg'

export const Nav = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const isActive = (path) => {
        return location.pathname === path;
    };

    const toggleMobileMenu = () => {
      setMobileMenuOpen(!mobileMenuOpen);
    };

    const handleProfile = () => {
      navigate('/recentactivities');
      setMobileMenuOpen(false);
    };
  
    const handleSignUp = () => {
      navigate('/signup');
      setMobileMenuOpen(false);
    };
  
    const handleLogin = () => {
      navigate('/login');
      setMobileMenuOpen(false);
    };

    const handleNavigate = (path) => {
      navigate(path);
      setMobileMenuOpen(false);
    };

    return (
      <>
      <nav className="sticky top-0 z-50 bg-transparent">
        <div className="max-w-8xl mx-auto pr-4 sm:px-6 lg:px-24">
          <div className="flex justify-between h-20">
            {/* Logo and desktop navigation */}
            <div className="flex items-center justify-between w-[47vw] ">
              <div className="flex-shrink-0 flex items-center">
                <a href="/" className="focus:outline-none">
                  {/* <span className="text-2xl font-bold bg-gradient-to-r from-violet-600 to-blue-500 text-transparent bg-clip-text">
                    Gomens
                  </span> */}
                  <img src={logo} alt="" className='md:w-[90px] w-[85px] h-[85px] md:h-[90px]'/>
                </a>
              </div>
              <div className="hidden md:flex items-center space-x-8 text-[18px]">
                 <a
                  href="/"
                 className={`${isActive('/') ? 'text-violet-700' : 'text-gray-700'} hover:text-violet-700 font-medium transition-colors duration-200`}
                >
                  Home
                </a>
                <a
                  href="/pricing"
                  className={`${isActive('/pricing') ? 'text-violet-700' : 'text-gray-700'} hover:text-violet-700 font-medium transition-colors duration-200`}
                >
                  Pricing
                </a>
                <a
                  href="/about"
                 className={`${isActive('/about') ? 'text-violet-700' : 'text-gray-700'} hover:text-violet-700 font-medium transition-colors duration-200`}
                >
                  About Us
                </a>
                 <a
                  href="/blogs"
                  className={`${isActive('/blogs') ? 'text-violet-700' : 'text-gray-700'} hover:text-violet-700 font-medium transition-colors duration-200`}
                >
                  Blog
                </a>
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden flex items-center">
              <button 
                onClick={toggleMobileMenu}
                className="text-gray-700 hover:text-violet-700 focus:outline-none"
                aria-label="Toggle menu"
              >
                {mobileMenuOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </button>
            </div>

            {/* Desktop authentication buttons */}
            <div className="hidden md:flex items-center gap-4">
              {currentUser ? (
                <div className="flex items-center gap-4">
                  <button
                    onClick={() => handleNavigate('/recentactivities')}
                    className="px-4 py-2 cursor-pointer bg-black text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                  >
                    Dashboard
                  </button>
                  <button onClick={handleProfile} className="focus:outline-none">
                    <div className="h-12 w-12 rounded-full text-xl bg-gradient-to-r from-indigo-500 to-purple-500 flex items-center justify-center text-white font-medium">
                      {currentUser.displayName ? currentUser.displayName.charAt(0).toUpperCase() : 'U'}
                    </div>
                  </button>
                </div>
              ) : (
                <>
                  <button
                    onClick={handleLogin}
                    className="px-5 py-2 cursor-pointer bg-gray-100 hover:bg-gray-200 rounded-lg font-medium text-gray-800 transition-colors duration-200"
                  >
                    Log in
                  </button>
                  <button
                    onClick={handleSignUp}
                    className="px-5 py-2 cursor-pointer bg-black text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
                  >
                    Try Now
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Mobile menu, show/hide based on menu state */}
        {/* Hamburger mobile menu */}
        <div
          className={`md:hidden fixed top-0 left-0 w-full z-50 transition-all duration-300 ${mobileMenuOpen ? 'block' : 'hidden'}`}
          aria-hidden={!mobileMenuOpen}
        >
          <div
            className="w-full bg-white shadow-lg rounded-b-lg p-6 animate-slideIn flex flex-col"
            style={{ height: '45vh', maxHeight: '100dvh', background: '#fff' }}
          >
            <button
              onClick={toggleMobileMenu}
              className="self-end mb-4 text-gray-700 hover:text-violet-700 focus:outline-none"
              aria-label="Close menu"
            >
              <X className="h-7 w-7" />
            </button>
            <div className="flex flex-col gap-2 flex-1">
              <a
                href="/pricing"
                className="block px-3 py-2 rounded-md text-lg font-semibold text-gray-700 hover:text-violet-700 hover:bg-gray-50"
                onClick={() => setMobileMenuOpen(false)}
              >
                Pricing
              </a>
              <a
                href="/about"
                className="block px-3 py-2 rounded-md text-lg font-semibold text-gray-700 hover:text-violet-700 hover:bg-gray-50"
                onClick={() => setMobileMenuOpen(false)}
              >
                About Us
              </a>
              <a
                href="/blogs"
                className="block px-3 py-2 rounded-md text-lg font-semibold text-gray-700 hover:text-violet-700 hover:bg-gray-50"
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog
              </a>
              {currentUser ? (
                <>
                  <div className="flex items-center space-x-3 mt-4">
                    <div className="h-10 w-10 rounded-full text-lg bg-gradient-to-r from-indigo-500 to-purple-500 flex items-center justify-center text-white font-medium">
                      {currentUser.displayName ? currentUser.displayName.charAt(0).toUpperCase() : 'U'}
                    </div>
                    <div className="font-semibold text-gray-800 text-lg">
                      {currentUser.displayName || currentUser.email}
                    </div>
                  </div>
                  <button
                    onClick={() => handleNavigate('/recentactivities')}
                    className="w-full px-4 py-2 bg-black text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-200 mt-2"
                  >
                    Dashboard
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={handleLogin}
                    className="cursor-pointer w-full px-4 py-2 bg-gray-400 hover:bg-gray-300 rounded-lg font-medium text-gray-800 transition-colors duration-200 mt-4"
                  >
                    Log in
                  </button>
                  <button
                    onClick={handleSignUp}
                    className="cursor-pointer w-full px-4 py-2 bg-black text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-200 mt-2"
                  >
                    Sign Up
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>
      </>
    )
}